
import { VehicleModel } from "../../../../model/VehicleModel";
import { IMessageModel } from "./IMessageModel";
import { MessageService } from "../service/messaging.service";

export class Conversation {
    vehicle: VehicleModel;
    lastMessage: IMessageModel;
    messages: IMessageModel[];

    unreadMessageCount: number;

    constructor(messageService: MessageService, private $filter: angular.IFilterService) {
        this.lastMessage = messageService.createMessageModel("", -1);
        this.lastMessage.Id = -1;
        this.messages = [];
        this.unreadMessageCount = 0;
    }

    getNextPageNumber(pageSize: number): number {
        return Math.ceil((this.messages.length + pageSize) / pageSize);
    }

    clearMessages() {
        this.messages = [];
    }

    applyNewMessages(messages: IMessageModel[]) {
        for (var i = 0; i < messages.length; i++) {
            var m = messages[i];

            this.updateOrPushMessage(m);
        }

        this.unreadMessageCount = 0;
        this.messages.forEach(message => {
            if (message.Originator === 1 && message.MsgCode !== 6) {
                this.unreadMessageCount++;
            }
        });

        this.messages = this.$filter("orderBy")(this.messages, arrayMessage => arrayMessage.Id, true);
    }

    private updateOrPushMessage(message: IMessageModel) {
        var found = false;
        for (var i = 0; i < this.messages.length; i++) {

            if (this.messages[i].Id === message.Id) {
                found = true;

                this.messages[i] = message;
            }
        }

        if (!found) {
            this.messages.push(message);
        }
    }
}
